/*
 * @Author: wangxuesong
 * @Date: 2024-03-13 14:03:54
 * @LastEditTime: 2024-04-18 15:48:24
 * @FilePath: \yl-cjsph-tms-carrier-frontd:\workspace\cjs\yl-cjsph-tms-operation-front\src\api\common.js
 * @Description:
 */
import request from '@/utils/request';
import { GATEWAY } from '@/utils/const';

// 获取全量数据字典
export function getDict(params) {
  return request({
    url: `${GATEWAY.CJS}/cjsSystemCategory/allData`,
    method: 'get',
    params
  });
}

/**
 * 大区、省、市请求接口
 * @param {*} data 父级code （查询大区不传）
 * @returns 子集市区数据
 */
export function reqQueryRegionList(params) {
  return request({
    url: `${GATEWAY.CJS}/area/queryRegionList`,
    method: 'get',
    params
  });
}

// 导出日志
export function exportLog(data) {
  return request({
    url: `${GATEWAY.CJS}/common/export/selectTask`,
    method: 'post',
    data
  });
}

// 导入导出下载
export function logDownload(data) {
  return request({
    url: `${GATEWAY.CJS}/file/oss/getDownloadSignedUrlDetails`,
    method: 'post',
    data
  });
}

// 导入日志
export function importLog(data) {
  return request({
    url: `${GATEWAY.CJS}/common/import/selectTask`,
    method: 'post',
    data
  });
}

// 短链接批量请求长连接  批量下载
export function batchDownload(data) {
  return request({
    url: `${GATEWAY.CJS}/file/oss/getDownloadSignedUrlDetails`,
    method: 'post',
    data
  });
}

// 获取腾讯滑块验证码开关状态
export function reqCaptchaSwitch(params) {
  return request({
    url: `${GATEWAY.CJS}/system/auth/captchaSwitch`,
    method: 'get',
    params
  });
}
